<script setup lang="ts">
import { t } from '@/utils/i18n';
import { trxWorkspaceSection } from '@/utils/trxNavigation';

const route = useRoute();
const consoleLinks = computed(() => [
  {
    label: t('Live operation'),
    to: '/trx?section=account',
    icon: 'mdi:view-dashboard-outline',
    active: route.path === '/trx' && trxWorkspaceSection(route.query.section) === 'account',
  },
  {
    label: t('Research and validation'),
    to: '/trx?section=comparison',
    icon: 'mdi:chart-timeline-variant',
    active: route.path === '/trx' && trxWorkspaceSection(route.query.section) !== 'account',
  },
  {
    label: t('Settings'),
    to: '/settings',
    icon: 'mdi:cog-outline',
    active: route.path === '/settings',
  },
]);
</script>

<template>
  <footer v-if="route.path !== '/login'" class="trx-mobile-footer">
    <nav aria-label="TRX 移动端导航">
      <RouterLink
        v-for="item in consoleLinks"
        :key="item.to"
        :to="item.to"
        :aria-current="item.active ? 'page' : undefined"
        :class="{ 'is-active': item.active }"
      >
        <UIcon :name="item.icon" class="size-5" aria-hidden="true" />
        <span>{{ item.label }}</span>
      </RouterLink>
    </nav>
  </footer>
</template>

<style scoped>
.trx-mobile-footer {
  display: none;
}
@media (max-width: 767px), (max-width: 1023px) and (max-height: 500px) {
  .trx-mobile-footer {
    display: block;
    flex-shrink: 0;
    border-top: 1px solid var(--ui-border);
    background: var(--ui-bg);
    padding-bottom: env(safe-area-inset-bottom, 0px);
  }
  .trx-mobile-footer nav {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .trx-mobile-footer a {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 3px;
    min-height: 56px;
    padding: 6px 4px;
    color: var(--ui-text-muted);
    font-size: 12px;
  }
  .trx-mobile-footer a.is-active {
    color: var(--ui-primary);
    background: color-mix(in srgb, var(--ui-primary) 8%, var(--ui-bg));
  }
  .trx-mobile-footer a:focus-visible {
    outline: 2px solid var(--ui-primary);
    outline-offset: -3px;
  }
}
</style>
